import React from 'react'

import User from "../../models/User"

import ErrorBanner from '../../components/ErrorBanner'
import LoadingBanner from '../../components/LoadingBanner'
import InfoTooltip from "../../components/InfoTooltip"
import PageNotAllowed from '../../components/errors/PageNotAllowed';

import Page from "../Page";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";

export default class ContractsList extends Page
{
    static path = '/contracts';

	constructor(props, context)
	{
		super(props, context);

		this.state = {
			...this.state,
        	platformContract: undefined,
        	contractedOpportunities: undefined,
            isLoading: true,
            error: null,
            isDisabled: false,
		};
	}

	componentDidMount()
	{
		super.componentDidMount();

		if (!this.context.auth?.isTalentSupplierResource()) {
			this.fetchContracts();
        }
	}

	async fetchContracts()
	{
		let user = this.context?.auth;
		if (!user) {
			return;
		}

        await this.promisedState({
        	platformContract: undefined,
        	contractedOpportunities: undefined,
            isLoading: true,
            error: null,
        });

		let contractGroups = await user.fetchContracts().catch(console.warn);

        if (!contractGroups) {
            return this.handleErrorResponse(
                User.FetchTalentContractsRequest, {
                    500: 'error_show_talent_contracts',
                }
            );
        }

        let platformContract = contractGroups.platform,
        	contractedOpportunities = contractGroups.opportunities;

        // console.log(contractedOpportunities)

        await this.promisedState({
        	platformContract,
        	contractedOpportunities,
        	isLoading: false,
        });
	}

	async signMasterAgreement()
	{
		let user = this.context?.auth;
		if (!user) {
			return;
		}

        await this.promisedState({
        	isDisabled: true,
        });

		let updatedUser = await user.signMasterContract().catch(console.warn);

		// console.log(updatedUser);

        if (!updatedUser) {
	        await this.promisedState({
	        	isDisabled: false,
	        });

            // handle error
            return;// TB.sysAlert('talent.contracts_sign_master_failed');
        }

        let contract = {...this.state.platformContract};
        contract.accepted_at = updatedUser.agreement_signed_at;

        await this.promisedState({
        	platformContract: contract,
        });

        // success message + link to finish profile
        await TB.sysAlert('talent.contracts_signed_master_agreement');

        await this.promisedState({
        	isDisabled: false,
        });

        this.props.navigate.push(
        	user.currentApplicationStep().getPath()
        	// TalentDashboardPage.path
        );
	}

	renderMasterContractSection()
	{
		if (!this.state.platformContract) {
			return <div/>;
		}

		let acceptedAt = this.state.platformContract.accepted_at;
		acceptedAt = acceptedAt ? TB.moment(acceptedAt) : null;
		if (acceptedAt && !acceptedAt.isValid()) {
			acceptedAt = null;
		}

		return (
			<div className='master-contract-container px-3 py-4'>
				<p className="mb-0"
					style={{flex:1}}>
                    {TB.trans('talent.contracts_list.master_contract_title')}
					`<InfoTooltip placement={'right'}>
                        {TB.trans('talent.contracts_list.master_contract_tooltips')}
                    </InfoTooltip>`
				</p>

				<div>

					{TB.isDefined(this.state.platformContract.path) && (
						<a href={this.state.platformContract.path}
							className="btn btn-outline-dark mr-3"
							target="_blank">
	                        {TB.trans('talent.contracts_list.view_pdf')}
						</a>
					)}

					{TB.isDefined(this.state.platformContract.path) && !TB.isDefined(acceptedAt) && (
						<button type="button"
							className="btn btn-outline-dark"
							onClick={this.signMasterAgreement.bind(this)}
							disabled={this.state.isDisabled}>
                            {TB.trans('talent.contracts_list.sign')}
						</button>
					)}

					{!TB.isDefined(this.state.platformContract.path) && (
						<p className="mb-0"
							style={{display: 'inline-block', fontSize: 12}}>
							Coming soon...
						</p>
					)}

					{TB.isDefined(acceptedAt) && (
						<p className="mb-0"
							style={{display: 'inline-block', fontSize: 12}}>
                            {TB.trans('talent.contracts_list.signed')} {acceptedAt.format('MM/D/Y')}
						</p>
					)}
				</div>
			</div>
		);
	}

	renderMobile = () => {
		return (
			<div>
				{this.state.contractedOpportunities.map((opp,i) => {
					return (
						<div className="bg-white my-6 border rounded border-gray-300 p-6">

							<div className="flex flex-row items-center gap-3 pb-2">
								<img
									alt={opp.project.client.name}
									src={opp.project?.client?.logo_path || TB.logoImagePath()}
									className="w-[70px]"
								/>

									<p className="text-xl">
										{opp.project.client.name}
									</p>
							</div>

							<div className="py-2">
								<p className="text-xs">Project</p>
								<p>{opp.project.name}</p>
							</div>

							<div className="py-2">
								<p className="text-xs">Document</p>
								<p>{opp.document.name || 'N/A'}</p>
							</div>

							<div className="flex gap-6 py-2">
								<div className="w-full">
									<p className="text-xs">Signed</p>
									<p>{opp.signed_at ? TB.moment(opp.signed_at).format('MM/DD/YY') : 'Not yet Signed'}</p>
								</div>

								<div className="w-full">
									<a href={opp.document.path} className="btn btn-outline-dark" target="_blank">
										View PDF
									</a>
								</div>
							</div>
						</div>
					)
				})}
			</div>
		)
	}

	renderProjectContractsSection()
	{
		if (!this.state.contractedOpportunities) {
			return <div/>;
		}

		if (!this.state.contractedOpportunities.length) {
			return (
				<div className='empty-project-contracts-container mt-5 p-5'>
                    {TB.trans('talent.contracts_list.no_projects_msg')}
				</div>
			);
		}

		return (
			<div className='project-contracts-container'>
				<table className="table table-bordered mt-4">
					<thead>
						<tr>
							<th style={{ width:'30%' }}>Client</th>
							<th style={{ width:'45%' }}>Project Name</th>
							<th style={{ width:'45%' }}>Document</th>
							<th style={{ width:'10%', minWidth: '120px' }}>Signed Date</th>
							<th style={{ width:'15%', minWidth: '155px' }}>Contract</th>
						</tr>
					</thead>
					<tbody>
						{this.state.contractedOpportunities.map((opp,i) => (
							<tr key={`talent-project-contracts-${i}`}>
								<td>
									<div className="flex flex-row items-center gap-3">
										<img
											alt={opp.project.client.name}
											src={opp.project?.client?.logo_path || TB.logoImagePath()}
											className="w-[50px]"/>

										{opp.project.client.name}

									</div>
								</td>
								<td>
									{opp.project.name}
								</td>
                                <td>
									{opp.document.name || 'N/A'}
								</td>
								<td className="text-center" >
									{opp.signed_at ? TB.moment(opp.signed_at).format('MM/DD/YY') : 'N/A'}
								</td>
								<td className="text-center">
									<a href={opp.document.path}
										className="btn btn-outline-dark"
										target="_blank">
										View PDF
									</a>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}

	render() {
		if (this.context.auth?.isTalentSupplierResource()) {
            return <PageNotAllowed redirect="/talent/dashboard" />
        }

		return (
			<div className='talent-portal-container'>
				<div className='talent-portal-page-container px-4'>
					{this.state.isLoading && <LoadingBanner message="Loading Contracts"/>}

	                {TB.isObject(this.state.error) && (
	                	<ErrorBanner {...this.state.error}
	                		onRetry={this.fetchContracts.bind(this)}/>
	                )}

	                {!this.state.isLoading && !TB.isObject(this.state.error) && (
						<>
							<div className='talent-contracts-panel hidden md:flex'>
								<h3 className='mb-5'>{TB.trans('talent.contracts_list.title')}</h3>

								<div className="contracts-container">
									{/*{this.renderMasterContractSection()}*/}

									{this.renderProjectContractsSection()}
								</div>
							</div>

							<div className="md:hidden pt-6">
								<h3 className='mb-5 text-xl text-center'>{TB.trans('talent.contracts_list.title')}</h3>

								{this.renderMobile()}
							</div>
						</>
	                )}
				</div>
			</div>
		);
	}
}

const TalentContractsList = (props) => {
	const navigate = useNavigate();

    const {auth, appropriate} = useAuth();
    if (auth.isTalent() && !auth.isProfileApproved()) {
        return <PageNotAllowed redirect="/talent/dashboard" message="Your profile must be approved before accessing this page."/>;
    }
	return (
		<ContractsList navigate={navigate}/>
	)
}

export {
	TalentContractsList
}